<template>
  <div>
    <div v-if="isHeaderShow">
      <svg
        v-if="status == 'onboarded' && hasAccount"
        class="highway-badge-check -mr-1 h-12 w-12"
        viewBox="0 0 38 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_106_35317)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.1571 24.4606C26.2804 24.4606 28.0016 22.7394 28.0016 20.6161C28.0016 19.8694 27.7888 19.1725 27.4205 18.5826L24.267 21.9004L23.9262 22.259L23.564 21.9219L21.8273 20.3057L22.5086 19.5736L23.8831 20.8528L26.7799 17.8051C26.093 17.1639 25.1709 16.7715 24.1571 16.7715C22.0338 16.7715 20.3125 18.4928 20.3125 20.6161C20.3125 22.7394 22.0338 24.4606 24.1571 24.4606Z"
            fill="#F8C617"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.7784 9.41797C23.1677 9.77676 22.2935 10.0021 21.3216 10.0021C20.3496 10.0021 19.4928 9.78091 18.8829 9.42791C18.2731 9.78091 17.4063 10.0021 16.4443 10.0021C15.4823 10.0021 14.5981 9.77676 13.9874 9.41797L11.1485 15.6542C10.876 16.2532 10.7311 16.9023 10.723 17.5603C10.7149 18.2183 10.8438 18.8707 11.1016 19.4762C11.3593 20.0817 11.7402 20.6269 12.2201 21.0772C12.6999 21.5275 13.2682 21.873 13.8888 22.0918L18.8829 23.8501L20.1503 23.4039C19.7722 22.858 19.5078 22.2379 19.3771 21.5806C19.1892 20.6358 19.2856 19.6565 19.6543 18.7665C20.0229 17.8765 20.6472 17.1158 21.4481 16.5807C22.2491 16.0455 23.1907 15.7598 24.154 15.7598C25.1591 15.7598 26.1321 16.0705 26.9447 16.6385C26.8734 16.3005 26.7652 15.9704 26.6215 15.6542L23.7784 9.41797Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.732 15.9744L21.3402 12.5293H19.5951L19.8995 14.8284H17.8716L18.176 12.5293H16.4309L13.8398 18.9622H17.3234L17.6286 16.6639H20.1425L20.2777 17.6842C20.6025 17.2571 20.9975 16.8842 21.4485 16.5829C21.8465 16.317 22.2792 16.1127 22.732 15.9744Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6616 8.39062L14.3525 8.79652C14.8296 9.07681 15.581 9.28121 16.4436 9.28121C17.306 9.28121 18.0421 9.08104 18.5206 8.80409L18.8823 8.59476L19.2439 8.80409C19.7229 9.08135 20.4493 9.28121 21.3209 9.28121C22.1928 9.28121 22.9344 9.07712 23.412 8.79652L24.1025 8.39085L27.278 15.3564C27.5652 15.9881 27.7293 16.6682 27.762 17.3602C27.7087 17.3014 27.6538 17.2438 27.5974 17.1874C27.1475 16.7375 26.6187 16.3847 26.0435 16.1425C26.0186 16.0793 25.992 16.0167 25.9638 15.9547L25.9635 15.9541L23.4212 10.3773C22.7997 10.6026 22.0765 10.7252 21.3209 10.7252C20.4146 10.7252 19.5692 10.5519 18.882 10.2395C18.1923 10.5521 17.3409 10.7252 16.4436 10.7252C15.6949 10.7252 14.9683 10.6026 14.344 10.3769L11.805 15.9543C11.574 16.462 11.4511 17.0124 11.4443 17.5702C11.4374 18.128 11.5467 18.6812 11.7652 19.1945C11.9837 19.7078 12.3066 20.17 12.7134 20.5518C13.1202 20.9334 13.6019 21.2263 14.1279 21.4118L18.8823 23.0857L19.7777 22.7705C19.9974 23.2199 20.286 23.6348 20.6351 23.9995L18.8823 24.6166L13.6484 22.7738C12.9333 22.5218 12.2782 22.1236 11.7253 21.6047C11.1724 21.0859 10.7336 20.4577 10.4366 19.76C10.1396 19.0624 9.9911 18.3106 10.0004 17.5524C10.0097 16.7943 10.1767 16.0464 10.4907 15.3562L13.6616 8.39062Z"
            fill="#F8C617"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_106_35317"
            x="0"
            y="3.39062"
            width="38"
            height="36.2266"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_106_35317"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_106_35317"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
      <svg
        v-else-if="
          (status == 'needs_to_onboard' ||
            status == 'needs_to_onboard_but_can_remain_active') &&
          hasAccount
        "
        class="highway-badge -mr-1 h-12 w-12"
        viewBox="0 0 38 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_419_87031)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.1551 24.07C26.2784 24.07 27.9997 22.3487 27.9997 20.2254C27.9997 19.4788 27.7868 18.7819 27.4185 18.192L24.2651 21.5097L23.9242 21.8683L23.562 21.5313L21.8253 19.9151L22.5066 19.183L23.8811 20.4622L26.7779 17.4144C26.091 16.7733 25.1689 16.3809 24.1551 16.3809C22.0318 16.3809 20.3105 18.1021 20.3105 20.2254C20.3105 22.3487 22.0318 24.07 24.1551 24.07Z"
            fill="#A9ADBD"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.7775 9.02734C23.1668 9.38614 22.2926 9.61152 21.3206 9.61152C20.3486 9.61152 19.4918 9.39028 18.882 9.03729C18.2721 9.39028 17.4053 9.61152 16.4433 9.61152C15.4813 9.61152 14.5971 9.38614 13.9864 9.02734L11.1476 15.2636C10.875 15.8625 10.7301 16.5116 10.722 17.1696C10.714 17.8276 10.8429 18.4801 11.1006 19.0856C11.3583 19.691 11.7392 20.2363 12.2191 20.6866C12.6989 21.1369 13.2672 21.4824 13.8878 21.7012L18.882 23.4595L20.1493 23.0133C19.7712 22.4674 19.5069 21.8473 19.3761 21.1899C19.1882 20.2452 19.2846 19.2658 19.6533 18.3759C20.0219 17.4859 20.6462 16.7252 21.4471 16.19C22.2481 15.6549 23.1898 15.3692 24.1531 15.3692C25.1581 15.3692 26.1311 15.6798 26.9437 16.2479C26.8724 15.9099 26.7642 15.5797 26.6205 15.2636L23.7775 9.02734Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.731 15.5837L21.3392 12.1387H19.5941L19.8985 14.4378H17.8706L18.175 12.1387H16.4299L13.8389 18.5716H17.3224L17.6276 16.2733H20.1416L20.2767 17.2936C20.6016 16.8664 20.9965 16.4936 21.4476 16.1922C21.8455 15.9263 22.2782 15.722 22.731 15.5837Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6616 8L14.3525 8.40589C14.8296 8.68619 15.581 8.89058 16.4436 8.89058C17.306 8.89058 18.0421 8.69041 18.5206 8.41347L18.8823 8.20413L19.2439 8.41347C19.7229 8.69072 20.4493 8.89058 21.3209 8.89058C22.1928 8.89058 22.9344 8.6865 23.412 8.40589L24.1025 8.00022L27.278 14.9658C27.5652 15.5975 27.7293 16.2776 27.762 16.9696C27.7087 16.9108 27.6538 16.8531 27.5974 16.7967C27.1475 16.3469 26.6187 15.9941 26.0435 15.7519C26.0186 15.6887 25.992 15.6261 25.9638 15.5641L25.9635 15.5634L23.4212 9.98668C22.7997 10.212 22.0765 10.3346 21.3209 10.3346C20.4146 10.3346 19.5692 10.1613 18.882 9.84883C18.1923 10.1615 17.3409 10.3346 16.4436 10.3346C15.6949 10.3346 14.9683 10.212 14.344 9.98625L11.805 15.5636C11.574 16.0714 11.4511 16.6218 11.4443 17.1796C11.4374 17.7374 11.5467 18.2905 11.7652 18.8039C11.9837 19.3172 12.3066 19.7794 12.7134 20.1611C13.1202 20.5428 13.6019 20.8357 14.1279 21.0212L18.8823 22.6951L19.7777 22.3798C19.9974 22.8292 20.286 23.2442 20.6351 23.6088L18.8823 24.226L13.6484 22.3832C12.9333 22.1311 12.2782 21.7329 11.7253 21.2141C11.1724 20.6952 10.7336 20.067 10.4366 19.3694C10.1396 18.6718 9.9911 17.92 10.0004 17.1618C10.0097 16.4037 10.1767 15.6557 10.4907 14.9656L13.6616 8Z"
            fill="#F8C617"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_419_87031"
            x="0"
            y="3"
            width="38"
            height="36.2266"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_419_87031"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_419_87031"
              result="shape"
            />
          </filter>
        </defs>
      </svg>

      <div
        v-else-if="status == 'onboarded' && !hasAccount"
        class="mr-0.5 flex h-10 w-10 items-center justify-center"
      >
        <svg
          class="h-6 w-6"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.1551 16.072C16.2784 16.072 17.9997 14.3507 17.9997 12.2274C17.9997 11.4805 17.7867 10.7834 17.4182 10.1935L14.2656 13.5103L13.9247 13.869L13.5625 13.5319L11.8258 11.9157L12.5071 11.1836L13.8816 12.4628L16.7775 9.41601C16.0907 8.77505 15.1687 8.38281 14.1551 8.38281C12.0318 8.38281 10.3105 10.1041 10.3105 12.2274C10.3105 14.3507 12.0318 16.072 14.1551 16.072Z"
            fill="#F8C617"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7321 7.58209L11.3402 4.13672H9.59512L9.89951 6.43584H7.87161L8.176 4.13672H6.43092L3.83984 10.5696H7.32336L7.62859 8.27133H10.1425L10.2777 9.29222C10.6027 8.86491 10.9977 8.49194 11.4489 8.19051C11.8468 7.92465 12.2794 7.72037 12.7321 7.58209Z"
            fill="#C7CBDB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.66162 0L4.35248 0.405891C4.82956 0.686185 5.58096 0.890584 6.44362 0.890584C7.306 0.890584 8.04211 0.690412 8.52058 0.413469L8.88226 0.20413L9.24393 0.413469C9.72294 0.690721 10.4493 0.890584 11.3209 0.890584C12.1928 0.890584 12.9344 0.686495 13.412 0.405891L14.1025 0.000224292L17.278 6.9658C17.5653 7.59761 17.7293 8.2778 17.762 8.9699C17.7088 8.91124 17.6541 8.85375 17.5978 8.79749C17.1479 8.34758 16.619 7.99478 16.0438 7.75258C16.0188 7.68916 15.9921 7.62632 15.9638 7.56411L15.9635 7.56344L13.4212 1.98668C12.7997 2.21202 12.0765 2.33456 11.3209 2.33456C10.4146 2.33456 9.56921 2.16128 8.88196 1.84883C8.19232 2.16146 7.34093 2.33456 6.44362 2.33456C5.6949 2.33456 4.96834 2.21197 4.34398 1.98625L1.80503 7.56363C1.57402 8.07138 1.45113 8.62176 1.44428 9.17955C1.43742 9.73739 1.54672 10.2905 1.76522 10.8039C1.98371 11.3172 2.30663 11.7794 2.71344 12.1611C3.12018 12.5428 3.60187 12.8357 4.12791 13.0212L8.88226 14.6951L9.77778 14.3798C9.99739 14.8292 10.2859 15.2442 10.6349 15.6089L8.88226 16.226L3.64837 14.3832C2.93329 14.1311 2.27822 13.7329 1.72533 13.2141C1.17244 12.6952 0.733562 12.067 0.436601 11.3694C0.13964 10.6718 -0.00890412 9.91996 0.00041264 9.16181C0.00972936 8.40366 0.176702 7.65574 0.490717 6.96561L3.66162 0Z"
            fill="#C7CBDB"
          />
        </svg>
      </div>
      <div
        v-else-if="
          (status == 'needs_to_onboard' ||
            status == 'needs_to_onboard_but_can_remain_active') &&
          !hasAccount
        "
        class="relative mr-0.5 flex h-10 w-10 items-center justify-center"
      >
        <svg
          class="h-6 w-6"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.1551 16.072C16.2784 16.072 17.9997 14.3507 17.9997 12.2274C17.9997 11.4805 17.7867 10.7834 17.4182 10.1935L14.2656 13.5103L13.9247 13.869L13.5625 13.5319L11.8258 11.9157L12.5071 11.1836L13.8816 12.4628L16.7775 9.41601C16.0907 8.77505 15.1687 8.38281 14.1551 8.38281C12.0318 8.38281 10.3105 10.1041 10.3105 12.2274C10.3105 14.3507 12.0318 16.072 14.1551 16.072Z"
            fill="#C7CBDB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7321 7.58209L11.3402 4.13672H9.59512L9.89951 6.43584H7.87161L8.176 4.13672H6.43092L3.83984 10.5696H7.32336L7.62859 8.27133H10.1425L10.2777 9.29222C10.6027 8.86491 10.9977 8.49194 11.4489 8.19051C11.8468 7.92465 12.2794 7.72037 12.7321 7.58209Z"
            fill="#C7CBDB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.66162 0L4.35248 0.405891C4.82956 0.686185 5.58096 0.890584 6.44362 0.890584C7.306 0.890584 8.04211 0.690412 8.52058 0.413469L8.88226 0.20413L9.24393 0.413469C9.72294 0.690721 10.4493 0.890584 11.3209 0.890584C12.1928 0.890584 12.9344 0.686495 13.412 0.405891L14.1025 0.000224292L17.278 6.9658C17.5653 7.59761 17.7293 8.2778 17.762 8.9699C17.7088 8.91124 17.6541 8.85375 17.5978 8.79749C17.1479 8.34758 16.619 7.99478 16.0438 7.75258C16.0188 7.68916 15.9921 7.62632 15.9638 7.56411L15.9635 7.56344L13.4212 1.98668C12.7997 2.21202 12.0765 2.33456 11.3209 2.33456C10.4146 2.33456 9.56921 2.16128 8.88196 1.84883C8.19232 2.16146 7.34093 2.33456 6.44362 2.33456C5.6949 2.33456 4.96834 2.21197 4.34398 1.98625L1.80503 7.56363C1.57402 8.07138 1.45113 8.62176 1.44428 9.17955C1.43742 9.73739 1.54672 10.2905 1.76522 10.8039C1.98371 11.3172 2.30663 11.7794 2.71344 12.1611C3.12018 12.5428 3.60187 12.8357 4.12791 13.0212L8.88226 14.6951L9.77778 14.3798C9.99739 14.8292 10.2859 15.2442 10.6349 15.6089L8.88226 16.226L3.64837 14.3832C2.93329 14.1311 2.27822 13.7329 1.72533 13.2141C1.17244 12.6952 0.733562 12.067 0.436601 11.3694C0.13964 10.6718 -0.00890412 9.91996 0.000412641 9.16181C0.00972936 8.40366 0.176702 7.65574 0.490717 6.96561L3.66162 0Z"
            fill="#C7CBDB"
          />
        </svg>
      </div>
      <div
        v-else-if="!status && !hasAccount"
        class="relative mr-0.5 flex h-10 w-10 items-center justify-center"
      >
        <svg
          class="h-6 w-6"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.70836 0L4.4087 0.412018C4.89125 0.695911 5.65186 0.903111 6.52716 0.903111C7.4023 0.903111 8.14822 0.700144 8.63209 0.419696L8.99859 0.207272L9.36523 0.41948C9.85066 0.700451 10.5886 0.903111 11.4714 0.903111C12.3542 0.903111 13.106 0.696273 13.5902 0.411798L14.2902 0.000532021L17.5019 7.05997C17.8205 7.75939 17.99 8.51748 17.9996 9.28597C18.0092 10.0545 17.8587 10.8165 17.5576 11.5237C17.2566 12.2308 16.8117 12.8676 16.2512 13.3934C15.6906 13.9192 15.0268 14.3226 14.3019 14.5778L8.99716 16.4455L3.69144 14.5775C2.96732 14.3213 2.3044 13.9173 1.74479 13.3912C1.18518 12.865 0.741126 12.2282 0.440832 11.5213C0.140537 10.8143 -0.0094293 10.0526 0.000459038 9.28458C0.0103452 8.5167 0.179802 7.75928 0.498066 7.0604L3.70836 0ZM13.5989 2.01339C12.9692 2.24171 12.2365 2.36588 11.4714 2.36588C10.5537 2.36588 9.69572 2.1903 8.99875 1.87359C8.30011 2.19053 7.43706 2.36588 6.52716 2.36588C5.76808 2.36588 5.03216 2.24175 4.39992 2.01308L1.82965 7.66586C1.59534 8.18025 1.47039 8.73821 1.46311 9.30341C1.45583 9.86861 1.56619 10.4291 1.78718 10.9494C2.00817 11.4697 2.33495 11.9383 2.74676 12.3254C3.15858 12.7126 3.64642 13.0099 4.1793 13.1984L8.99716 14.8947L13.8161 13.1981C14.3495 13.0103 14.838 12.7135 15.2504 12.3266C15.6629 11.9397 15.9902 11.4711 16.2117 10.9508C16.4332 10.4304 16.544 9.8697 16.5369 9.30422C16.5299 8.73875 16.4052 8.18094 16.1707 7.66629L13.5989 2.01339Z"
            fill="#C7CBDB"
          />
          <path
            d="M10.5817 10.9481H14.1115L11.4869 4.42969H9.71859L10.027 6.75936H7.97218L8.28062 4.42969H6.51235L3.8877 10.9481H7.4175L7.72593 8.61922H10.2733L10.5817 10.9481Z"
            fill="#C7CBDB"
          />
        </svg>
      </div>

      <!-- <div v-else-if="status == 'onboarded' && !hasAccount" class="w-8 h-10 flex justify-start items-center">
                <svg class="w-6 h-6 flex items-center" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30466 12.2119C9.35139 12.2119 11.8212 9.74201 11.8212 6.69529C11.8212 5.8144 11.6148 4.98173 11.2476 4.24303L6.49714 8.99348L5.93988 9.55074L5.38262 8.99348L2.95534 6.56621L4.06986 5.45169L5.93988 7.32171L10.3341 2.92748C9.32739 1.8513 7.89458 1.17871 6.30466 1.17871C3.25794 1.17871 0.788086 3.64857 0.788086 6.69529C0.788086 9.74201 3.25794 12.2119 6.30466 12.2119Z" fill="#f8c617"/>
                </svg>
            </div>
            <div v-else-if="status == 'needs_to_onboard' && !hasAccount" class="w-8 h-10 flex justify-start items-center">
                <svg class="w-6 h-6" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30466 12.2119C9.35139 12.2119 11.8212 9.74201 11.8212 6.69529C11.8212 5.8144 11.6148 4.98173 11.2476 4.24303L6.49714 8.99348L5.93988 9.55074L5.38262 8.99348L2.95534 6.56621L4.06986 5.45169L5.93988 7.32171L10.3341 2.92748C9.32739 1.8513 7.89458 1.17871 6.30466 1.17871C3.25794 1.17871 0.788086 3.64857 0.788086 6.69529C0.788086 9.74201 3.25794 12.2119 6.30466 12.2119Z" fill="#C7CBDB"/>
                </svg>
            </div> -->
      <svg
        v-else-if="hasAccount"
        class="highway-badge -mr-1 h-12 w-12"
        viewBox="0 0 38 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_106_35316)">
          <path
            d="M23.9689 9.43359C23.3495 9.7975 22.4628 10.0261 21.4778 10.0261C20.4928 10.0261 19.6222 9.8017 19.0036 9.44368C18.3859 9.8017 17.5068 10.0261 16.5302 10.0261C15.5536 10.0261 14.6577 9.7975 14.0392 9.43359L11.1632 15.7587C10.8867 16.3658 10.7395 17.0238 10.7309 17.6908C10.7223 18.3579 10.8525 19.0195 11.1134 19.6335C11.3742 20.2476 11.7599 20.8006 12.2459 21.2576C12.7319 21.7146 13.3077 22.0654 13.9367 22.2879L19.0019 24.0713L24.0672 22.2879C24.6968 22.0663 25.2734 21.716 25.7602 21.2593C26.247 20.8026 26.6334 20.2496 26.8949 19.6354C27.1563 19.0213 27.287 18.3594 27.2787 17.6919C27.2703 17.0245 27.1232 16.3661 26.8465 15.7587L23.9689 9.43359Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.7084 8.39062L14.4087 8.80264C14.8913 9.08654 15.6519 9.29374 16.5272 9.29374C17.4023 9.29374 18.1482 9.09077 18.6321 8.81032L18.9986 8.5979L19.3652 8.81011C19.8507 9.09108 20.5886 9.29374 21.4714 9.29374C22.3542 9.29374 23.106 9.0869 23.5902 8.80242L24.2902 8.39116L27.5019 15.4506C27.8205 16.15 27.99 16.9081 27.9996 17.6766C28.0092 18.4451 27.8587 19.2072 27.5576 19.9143C27.2566 20.6215 26.8117 21.2582 26.2512 21.784C25.6906 22.3098 25.0268 22.7132 24.3019 22.9684L18.9972 24.8361L13.6914 22.9681C12.9673 22.7119 12.3044 22.3079 11.7448 21.7818C11.1852 21.2556 10.7411 20.6189 10.4408 19.9119C10.1405 19.2049 9.99057 18.4432 10.0005 17.6752C10.0103 16.9073 10.1798 16.1499 10.4981 15.451L13.7084 8.39062ZM23.5989 10.404C22.9692 10.6323 22.2365 10.7565 21.4714 10.7565C20.5537 10.7565 19.6957 10.5809 18.9988 10.2642C18.3001 10.5812 17.4371 10.7565 16.5272 10.7565C15.7681 10.7565 15.0322 10.6324 14.3999 10.4037L11.8297 16.0565C11.5953 16.5709 11.4704 17.1288 11.4631 17.694C11.4558 18.2592 11.5662 18.8198 11.7872 19.34C12.0082 19.8603 12.3349 20.3289 12.7468 20.7161C13.1586 21.1032 13.6464 21.4005 14.1793 21.5891L18.9972 23.2853L23.8161 21.5887C24.3495 21.4009 24.838 21.1041 25.2504 20.7172C25.6629 20.3303 25.9902 19.8617 26.2117 19.3414C26.4332 18.8211 26.544 18.2603 26.5369 17.6948C26.5299 17.1294 26.4052 16.5716 26.1707 16.0569L23.5989 10.404Z"
            fill="#F8C617"
          />
          <path
            d="M20.5807 19.3387H24.1105L21.4859 12.8203H19.7176L20.0261 15.15H17.9712L18.2796 12.8203H16.5114L13.8867 19.3387H17.4165L17.725 17.0098H20.2723L20.5807 19.3387Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_106_35316"
            x="0"
            y="3.39062"
            width="38"
            height="36.4453"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_106_35316"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_106_35316"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
    <div v-if="!isHeaderShow">
      <svg
        v-if="status == 'onboarded' && hasAccount"
        class="highway-badge-check relative h-14 w-14"
        style="top: 7px"
        viewBox="0 0 38 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_106_35317)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.1571 24.4606C26.2804 24.4606 28.0016 22.7394 28.0016 20.6161C28.0016 19.8694 27.7888 19.1725 27.4205 18.5826L24.267 21.9004L23.9262 22.259L23.564 21.9219L21.8273 20.3057L22.5086 19.5736L23.8831 20.8528L26.7799 17.8051C26.093 17.1639 25.1709 16.7715 24.1571 16.7715C22.0338 16.7715 20.3125 18.4928 20.3125 20.6161C20.3125 22.7394 22.0338 24.4606 24.1571 24.4606Z"
            fill="#F8C617"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.7784 9.41797C23.1677 9.77676 22.2935 10.0021 21.3216 10.0021C20.3496 10.0021 19.4928 9.78091 18.8829 9.42791C18.2731 9.78091 17.4063 10.0021 16.4443 10.0021C15.4823 10.0021 14.5981 9.77676 13.9874 9.41797L11.1485 15.6542C10.876 16.2532 10.7311 16.9023 10.723 17.5603C10.7149 18.2183 10.8438 18.8707 11.1016 19.4762C11.3593 20.0817 11.7402 20.6269 12.2201 21.0772C12.6999 21.5275 13.2682 21.873 13.8888 22.0918L18.8829 23.8501L20.1503 23.4039C19.7722 22.858 19.5078 22.2379 19.3771 21.5806C19.1892 20.6358 19.2856 19.6565 19.6543 18.7665C20.0229 17.8765 20.6472 17.1158 21.4481 16.5807C22.2491 16.0455 23.1907 15.7598 24.154 15.7598C25.1591 15.7598 26.1321 16.0705 26.9447 16.6385C26.8734 16.3005 26.7652 15.9704 26.6215 15.6542L23.7784 9.41797Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.732 15.9744L21.3402 12.5293H19.5951L19.8995 14.8284H17.8716L18.176 12.5293H16.4309L13.8398 18.9622H17.3234L17.6286 16.6639H20.1425L20.2777 17.6842C20.6025 17.2571 20.9975 16.8842 21.4485 16.5829C21.8465 16.317 22.2792 16.1127 22.732 15.9744Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6616 8.39062L14.3525 8.79652C14.8296 9.07681 15.581 9.28121 16.4436 9.28121C17.306 9.28121 18.0421 9.08104 18.5206 8.80409L18.8823 8.59476L19.2439 8.80409C19.7229 9.08135 20.4493 9.28121 21.3209 9.28121C22.1928 9.28121 22.9344 9.07712 23.412 8.79652L24.1025 8.39085L27.278 15.3564C27.5652 15.9881 27.7293 16.6682 27.762 17.3602C27.7087 17.3014 27.6538 17.2438 27.5974 17.1874C27.1475 16.7375 26.6187 16.3847 26.0435 16.1425C26.0186 16.0793 25.992 16.0167 25.9638 15.9547L25.9635 15.9541L23.4212 10.3773C22.7997 10.6026 22.0765 10.7252 21.3209 10.7252C20.4146 10.7252 19.5692 10.5519 18.882 10.2395C18.1923 10.5521 17.3409 10.7252 16.4436 10.7252C15.6949 10.7252 14.9683 10.6026 14.344 10.3769L11.805 15.9543C11.574 16.462 11.4511 17.0124 11.4443 17.5702C11.4374 18.128 11.5467 18.6812 11.7652 19.1945C11.9837 19.7078 12.3066 20.17 12.7134 20.5518C13.1202 20.9334 13.6019 21.2263 14.1279 21.4118L18.8823 23.0857L19.7777 22.7705C19.9974 23.2199 20.286 23.6348 20.6351 23.9995L18.8823 24.6166L13.6484 22.7738C12.9333 22.5218 12.2782 22.1236 11.7253 21.6047C11.1724 21.0859 10.7336 20.4577 10.4366 19.76C10.1396 19.0624 9.9911 18.3106 10.0004 17.5524C10.0097 16.7943 10.1767 16.0464 10.4907 15.3562L13.6616 8.39062Z"
            fill="#F8C617"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_106_35317"
            x="0"
            y="3.39062"
            width="38"
            height="36.2266"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_106_35317"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_106_35317"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
      <svg
        v-else-if="
          (status == 'needs_to_onboard' ||
            status == 'needs_to_onboard_but_can_remain_active') &&
          hasAccount
        "
        class="highway-badge relative h-14 w-14"
        style="top: 7px"
        viewBox="0 0 38 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_419_87031)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.1551 24.07C26.2784 24.07 27.9997 22.3487 27.9997 20.2254C27.9997 19.4788 27.7868 18.7819 27.4185 18.192L24.2651 21.5097L23.9242 21.8683L23.562 21.5313L21.8253 19.9151L22.5066 19.183L23.8811 20.4622L26.7779 17.4144C26.091 16.7733 25.1689 16.3809 24.1551 16.3809C22.0318 16.3809 20.3105 18.1021 20.3105 20.2254C20.3105 22.3487 22.0318 24.07 24.1551 24.07Z"
            fill="#A9ADBD"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.7775 9.02734C23.1668 9.38614 22.2926 9.61152 21.3206 9.61152C20.3486 9.61152 19.4918 9.39028 18.882 9.03729C18.2721 9.39028 17.4053 9.61152 16.4433 9.61152C15.4813 9.61152 14.5971 9.38614 13.9864 9.02734L11.1476 15.2636C10.875 15.8625 10.7301 16.5116 10.722 17.1696C10.714 17.8276 10.8429 18.4801 11.1006 19.0856C11.3583 19.691 11.7392 20.2363 12.2191 20.6866C12.6989 21.1369 13.2672 21.4824 13.8878 21.7012L18.882 23.4595L20.1493 23.0133C19.7712 22.4674 19.5069 21.8473 19.3761 21.1899C19.1882 20.2452 19.2846 19.2658 19.6533 18.3759C20.0219 17.4859 20.6462 16.7252 21.4471 16.19C22.2481 15.6549 23.1898 15.3692 24.1531 15.3692C25.1581 15.3692 26.1311 15.6798 26.9437 16.2479C26.8724 15.9099 26.7642 15.5797 26.6205 15.2636L23.7775 9.02734Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.731 15.5837L21.3392 12.1387H19.5941L19.8985 14.4378H17.8706L18.175 12.1387H16.4299L13.8389 18.5716H17.3224L17.6276 16.2733H20.1416L20.2767 17.2936C20.6016 16.8664 20.9965 16.4936 21.4476 16.1922C21.8455 15.9263 22.2782 15.722 22.731 15.5837Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6616 8L14.3525 8.40589C14.8296 8.68619 15.581 8.89058 16.4436 8.89058C17.306 8.89058 18.0421 8.69041 18.5206 8.41347L18.8823 8.20413L19.2439 8.41347C19.7229 8.69072 20.4493 8.89058 21.3209 8.89058C22.1928 8.89058 22.9344 8.6865 23.412 8.40589L24.1025 8.00022L27.278 14.9658C27.5652 15.5975 27.7293 16.2776 27.762 16.9696C27.7087 16.9108 27.6538 16.8531 27.5974 16.7967C27.1475 16.3469 26.6187 15.9941 26.0435 15.7519C26.0186 15.6887 25.992 15.6261 25.9638 15.5641L25.9635 15.5634L23.4212 9.98668C22.7997 10.212 22.0765 10.3346 21.3209 10.3346C20.4146 10.3346 19.5692 10.1613 18.882 9.84883C18.1923 10.1615 17.3409 10.3346 16.4436 10.3346C15.6949 10.3346 14.9683 10.212 14.344 9.98625L11.805 15.5636C11.574 16.0714 11.4511 16.6218 11.4443 17.1796C11.4374 17.7374 11.5467 18.2905 11.7652 18.8039C11.9837 19.3172 12.3066 19.7794 12.7134 20.1611C13.1202 20.5428 13.6019 20.8357 14.1279 21.0212L18.8823 22.6951L19.7777 22.3798C19.9974 22.8292 20.286 23.2442 20.6351 23.6088L18.8823 24.226L13.6484 22.3832C12.9333 22.1311 12.2782 21.7329 11.7253 21.2141C11.1724 20.6952 10.7336 20.067 10.4366 19.3694C10.1396 18.6718 9.9911 17.92 10.0004 17.1618C10.0097 16.4037 10.1767 15.6557 10.4907 14.9656L13.6616 8Z"
            fill="#F8C617"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_419_87031"
            x="0"
            y="3"
            width="38"
            height="36.2266"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_419_87031"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_419_87031"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
      <!-- OLD LARGE CHECKMARKS -->
      <!-- <div v-else-if="status == 'onboarded' && !hasAccount" class="w-14 h-14 flex justify-center items-center">
                <svg class="w-7 h-7 flex items-center" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30466 12.2119C9.35139 12.2119 11.8212 9.74201 11.8212 6.69529C11.8212 5.8144 11.6148 4.98173 11.2476 4.24303L6.49714 8.99348L5.93988 9.55074L5.38262 8.99348L2.95534 6.56621L4.06986 5.45169L5.93988 7.32171L10.3341 2.92748C9.32739 1.8513 7.89458 1.17871 6.30466 1.17871C3.25794 1.17871 0.788086 3.64857 0.788086 6.69529C0.788086 9.74201 3.25794 12.2119 6.30466 12.2119Z" fill="#f8c617"/>
                </svg>
            </div> -->
      <!-- <div v-else-if="status == 'needs_to_onboard' && !hasAccount" class="w-14 h-14 flex justify-center items-center">
                <svg class="w-7 h-7" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30466 12.2119C9.35139 12.2119 11.8212 9.74201 11.8212 6.69529C11.8212 5.8144 11.6148 4.98173 11.2476 4.24303L6.49714 8.99348L5.93988 9.55074L5.38262 8.99348L2.95534 6.56621L4.06986 5.45169L5.93988 7.32171L10.3341 2.92748C9.32739 1.8513 7.89458 1.17871 6.30466 1.17871C3.25794 1.17871 0.788086 3.64857 0.788086 6.69529C0.788086 9.74201 3.25794 12.2119 6.30466 12.2119Z" fill="#C7CBDB"/>
                </svg>
            </div> -->
      <div
        v-else-if="status == 'do_not_dispatch'"
        class="flex h-14 w-14 items-center justify-center"
      >
        <svg
          class="h-7 w-7 text-red-500"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <div
        v-else-if="status == 'onboarded' && !hasAccount"
        class="flex h-14 w-14 items-center justify-center"
      >
        <svg
          class="h-6 w-6"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.1551 16.072C16.2784 16.072 17.9997 14.3507 17.9997 12.2274C17.9997 11.4805 17.7867 10.7834 17.4182 10.1935L14.2656 13.5103L13.9247 13.869L13.5625 13.5319L11.8258 11.9157L12.5071 11.1836L13.8816 12.4628L16.7775 9.41601C16.0907 8.77505 15.1687 8.38281 14.1551 8.38281C12.0318 8.38281 10.3105 10.1041 10.3105 12.2274C10.3105 14.3507 12.0318 16.072 14.1551 16.072Z"
            fill="#F8C617"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7321 7.58209L11.3402 4.13672H9.59512L9.89951 6.43584H7.87161L8.176 4.13672H6.43092L3.83984 10.5696H7.32336L7.62859 8.27133H10.1425L10.2777 9.29222C10.6027 8.86491 10.9977 8.49194 11.4489 8.19051C11.8468 7.92465 12.2794 7.72037 12.7321 7.58209Z"
            fill="#C7CBDB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.66162 0L4.35248 0.405891C4.82956 0.686185 5.58096 0.890584 6.44362 0.890584C7.306 0.890584 8.04211 0.690412 8.52058 0.413469L8.88226 0.20413L9.24393 0.413469C9.72294 0.690721 10.4493 0.890584 11.3209 0.890584C12.1928 0.890584 12.9344 0.686495 13.412 0.405891L14.1025 0.000224292L17.278 6.9658C17.5653 7.59761 17.7293 8.2778 17.762 8.9699C17.7088 8.91124 17.6541 8.85375 17.5978 8.79749C17.1479 8.34758 16.619 7.99478 16.0438 7.75258C16.0188 7.68916 15.9921 7.62632 15.9638 7.56411L15.9635 7.56344L13.4212 1.98668C12.7997 2.21202 12.0765 2.33456 11.3209 2.33456C10.4146 2.33456 9.56921 2.16128 8.88196 1.84883C8.19232 2.16146 7.34093 2.33456 6.44362 2.33456C5.6949 2.33456 4.96834 2.21197 4.34398 1.98625L1.80503 7.56363C1.57402 8.07138 1.45113 8.62176 1.44428 9.17955C1.43742 9.73739 1.54672 10.2905 1.76522 10.8039C1.98371 11.3172 2.30663 11.7794 2.71344 12.1611C3.12018 12.5428 3.60187 12.8357 4.12791 13.0212L8.88226 14.6951L9.77778 14.3798C9.99739 14.8292 10.2859 15.2442 10.6349 15.6089L8.88226 16.226L3.64837 14.3832C2.93329 14.1311 2.27822 13.7329 1.72533 13.2141C1.17244 12.6952 0.733562 12.067 0.436601 11.3694C0.13964 10.6718 -0.00890412 9.91996 0.00041264 9.16181C0.00972936 8.40366 0.176702 7.65574 0.490717 6.96561L3.66162 0Z"
            fill="#C7CBDB"
          />
        </svg>
      </div>
      <div
        v-else-if="
          (status == 'needs_to_onboard' ||
            status == 'needs_to_onboard_but_can_remain_active') &&
          !hasAccount
        "
        class="relative flex h-14 w-14 items-center justify-center"
      >
        <svg
          class="h-6 w-6"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.1551 16.072C16.2784 16.072 17.9997 14.3507 17.9997 12.2274C17.9997 11.4805 17.7867 10.7834 17.4182 10.1935L14.2656 13.5103L13.9247 13.869L13.5625 13.5319L11.8258 11.9157L12.5071 11.1836L13.8816 12.4628L16.7775 9.41601C16.0907 8.77505 15.1687 8.38281 14.1551 8.38281C12.0318 8.38281 10.3105 10.1041 10.3105 12.2274C10.3105 14.3507 12.0318 16.072 14.1551 16.072Z"
            fill="#C7CBDB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.7321 7.58209L11.3402 4.13672H9.59512L9.89951 6.43584H7.87161L8.176 4.13672H6.43092L3.83984 10.5696H7.32336L7.62859 8.27133H10.1425L10.2777 9.29222C10.6027 8.86491 10.9977 8.49194 11.4489 8.19051C11.8468 7.92465 12.2794 7.72037 12.7321 7.58209Z"
            fill="#C7CBDB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.66162 0L4.35248 0.405891C4.82956 0.686185 5.58096 0.890584 6.44362 0.890584C7.306 0.890584 8.04211 0.690412 8.52058 0.413469L8.88226 0.20413L9.24393 0.413469C9.72294 0.690721 10.4493 0.890584 11.3209 0.890584C12.1928 0.890584 12.9344 0.686495 13.412 0.405891L14.1025 0.000224292L17.278 6.9658C17.5653 7.59761 17.7293 8.2778 17.762 8.9699C17.7088 8.91124 17.6541 8.85375 17.5978 8.79749C17.1479 8.34758 16.619 7.99478 16.0438 7.75258C16.0188 7.68916 15.9921 7.62632 15.9638 7.56411L15.9635 7.56344L13.4212 1.98668C12.7997 2.21202 12.0765 2.33456 11.3209 2.33456C10.4146 2.33456 9.56921 2.16128 8.88196 1.84883C8.19232 2.16146 7.34093 2.33456 6.44362 2.33456C5.6949 2.33456 4.96834 2.21197 4.34398 1.98625L1.80503 7.56363C1.57402 8.07138 1.45113 8.62176 1.44428 9.17955C1.43742 9.73739 1.54672 10.2905 1.76522 10.8039C1.98371 11.3172 2.30663 11.7794 2.71344 12.1611C3.12018 12.5428 3.60187 12.8357 4.12791 13.0212L8.88226 14.6951L9.77778 14.3798C9.99739 14.8292 10.2859 15.2442 10.6349 15.6089L8.88226 16.226L3.64837 14.3832C2.93329 14.1311 2.27822 13.7329 1.72533 13.2141C1.17244 12.6952 0.733562 12.067 0.436601 11.3694C0.13964 10.6718 -0.00890412 9.91996 0.000412641 9.16181C0.00972936 8.40366 0.176702 7.65574 0.490717 6.96561L3.66162 0Z"
            fill="#C7CBDB"
          />
        </svg>
      </div>
      <div
        v-else-if="!status && !hasAccount"
        class="relative flex h-14 w-14 items-center justify-center"
      >
        <svg
          class="h-6 w-6"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.70836 0L4.4087 0.412018C4.89125 0.695911 5.65186 0.903111 6.52716 0.903111C7.4023 0.903111 8.14822 0.700144 8.63209 0.419696L8.99859 0.207272L9.36523 0.41948C9.85066 0.700451 10.5886 0.903111 11.4714 0.903111C12.3542 0.903111 13.106 0.696273 13.5902 0.411798L14.2902 0.000532021L17.5019 7.05997C17.8205 7.75939 17.99 8.51748 17.9996 9.28597C18.0092 10.0545 17.8587 10.8165 17.5576 11.5237C17.2566 12.2308 16.8117 12.8676 16.2512 13.3934C15.6906 13.9192 15.0268 14.3226 14.3019 14.5778L8.99716 16.4455L3.69144 14.5775C2.96732 14.3213 2.3044 13.9173 1.74479 13.3912C1.18518 12.865 0.741126 12.2282 0.440832 11.5213C0.140537 10.8143 -0.0094293 10.0526 0.000459038 9.28458C0.0103452 8.5167 0.179802 7.75928 0.498066 7.0604L3.70836 0ZM13.5989 2.01339C12.9692 2.24171 12.2365 2.36588 11.4714 2.36588C10.5537 2.36588 9.69572 2.1903 8.99875 1.87359C8.30011 2.19053 7.43706 2.36588 6.52716 2.36588C5.76808 2.36588 5.03216 2.24175 4.39992 2.01308L1.82965 7.66586C1.59534 8.18025 1.47039 8.73821 1.46311 9.30341C1.45583 9.86861 1.56619 10.4291 1.78718 10.9494C2.00817 11.4697 2.33495 11.9383 2.74676 12.3254C3.15858 12.7126 3.64642 13.0099 4.1793 13.1984L8.99716 14.8947L13.8161 13.1981C14.3495 13.0103 14.838 12.7135 15.2504 12.3266C15.6629 11.9397 15.9902 11.4711 16.2117 10.9508C16.4332 10.4304 16.544 9.8697 16.5369 9.30422C16.5299 8.73875 16.4052 8.18094 16.1707 7.66629L13.5989 2.01339Z"
            fill="#C7CBDB"
          />
          <path
            d="M10.5817 10.9481H14.1115L11.4869 4.42969H9.71859L10.027 6.75936H7.97218L8.28062 4.42969H6.51235L3.8877 10.9481H7.4175L7.72593 8.61922H10.2733L10.5817 10.9481Z"
            fill="#C7CBDB"
          />
        </svg>
      </div>
      <svg
        v-else-if="hasAccount"
        class="highway-badge relative h-14 w-14"
        style="top: 7px"
        viewBox="0 0 38 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_106_35316)">
          <path
            d="M23.9689 9.43359C23.3495 9.7975 22.4628 10.0261 21.4778 10.0261C20.4928 10.0261 19.6222 9.8017 19.0036 9.44368C18.3859 9.8017 17.5068 10.0261 16.5302 10.0261C15.5536 10.0261 14.6577 9.7975 14.0392 9.43359L11.1632 15.7587C10.8867 16.3658 10.7395 17.0238 10.7309 17.6908C10.7223 18.3579 10.8525 19.0195 11.1134 19.6335C11.3742 20.2476 11.7599 20.8006 12.2459 21.2576C12.7319 21.7146 13.3077 22.0654 13.9367 22.2879L19.0019 24.0713L24.0672 22.2879C24.6968 22.0663 25.2734 21.716 25.7602 21.2593C26.247 20.8026 26.6334 20.2496 26.8949 19.6354C27.1563 19.0213 27.287 18.3594 27.2787 17.6919C27.2703 17.0245 27.1232 16.3661 26.8465 15.7587L23.9689 9.43359Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.7084 8.39062L14.4087 8.80264C14.8913 9.08654 15.6519 9.29374 16.5272 9.29374C17.4023 9.29374 18.1482 9.09077 18.6321 8.81032L18.9986 8.5979L19.3652 8.81011C19.8507 9.09108 20.5886 9.29374 21.4714 9.29374C22.3542 9.29374 23.106 9.0869 23.5902 8.80242L24.2902 8.39116L27.5019 15.4506C27.8205 16.15 27.99 16.9081 27.9996 17.6766C28.0092 18.4451 27.8587 19.2072 27.5576 19.9143C27.2566 20.6215 26.8117 21.2582 26.2512 21.784C25.6906 22.3098 25.0268 22.7132 24.3019 22.9684L18.9972 24.8361L13.6914 22.9681C12.9673 22.7119 12.3044 22.3079 11.7448 21.7818C11.1852 21.2556 10.7411 20.6189 10.4408 19.9119C10.1405 19.2049 9.99057 18.4432 10.0005 17.6752C10.0103 16.9073 10.1798 16.1499 10.4981 15.451L13.7084 8.39062ZM23.5989 10.404C22.9692 10.6323 22.2365 10.7565 21.4714 10.7565C20.5537 10.7565 19.6957 10.5809 18.9988 10.2642C18.3001 10.5812 17.4371 10.7565 16.5272 10.7565C15.7681 10.7565 15.0322 10.6324 14.3999 10.4037L11.8297 16.0565C11.5953 16.5709 11.4704 17.1288 11.4631 17.694C11.4558 18.2592 11.5662 18.8198 11.7872 19.34C12.0082 19.8603 12.3349 20.3289 12.7468 20.7161C13.1586 21.1032 13.6464 21.4005 14.1793 21.5891L18.9972 23.2853L23.8161 21.5887C24.3495 21.4009 24.838 21.1041 25.2504 20.7172C25.6629 20.3303 25.9902 19.8617 26.2117 19.3414C26.4332 18.8211 26.544 18.2603 26.5369 17.6948C26.5299 17.1294 26.4052 16.5716 26.1707 16.0569L23.5989 10.404Z"
            fill="#F8C617"
          />
          <path
            d="M20.5807 19.3387H24.1105L21.4859 12.8203H19.7176L20.0261 15.15H17.9712L18.2796 12.8203H16.5114L13.8867 19.3387H17.4165L17.725 17.0098H20.2723L20.5807 19.3387Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_106_35316"
            x="0"
            y="3.39062"
            width="38"
            height="36.4453"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.972549 0 0 0 0 0.776471 0 0 0 0 0.0901961 0 0 0 0.3 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_106_35316"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_106_35316"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BrokerBadge',
  props: {
    isHeaderShow: {
      type: Boolean,
      required: false,
      default: false,
    },
    highwayStatus: {
      type: String,
      required: false,
      default: '',
    },
    connectionStatus: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    hasAccount() {
      if (this.isHeaderShow == true) {
        if (
          this.$store.state.show.showBroker?.broker_company_id !== null &&
          this.$store.state.show.showBroker?.broker_company_id > 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        //! For Connections page (or other)
        if (this.highwayStatus?.length > 0 && this.highwayStatus !== '') {
          let status = this.highwayStatus
            ?.trim()
            ?.toLowerCase()
            ?.replaceAll(' ', '_');
          if (status == 'connected') {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    status() {
      if (this.isHeaderShow == true) {
        if (this.$store.state.show.showBroker?.connection?.[0]?.status) {
          return this.$store.state.show.showBroker?.connection?.[0]?.status;
        } else {
          return false;
        }
      } else {
        //! For Connections page (or other)
        if (this.connectionStatus?.length > 0 && this.connectionStatus !== '') {
          return this.connectionStatus
            ?.trim()
            ?.toLowerCase()
            ?.replaceAll(' ', '_');
        } else {
          return false;
        }
      }
    },
  },
  watch: {
    hasAccount: {
      handler() {
        this.emitPopperMessage();
      },
      immediate: true,
    },
    status: {
      handler() {
        this.emitPopperMessage();
      },
      immediate: true,
    },
  },
  methods: {
    emitPopperMessage() {
      let msg = '';
      if (this.status == 'onboarded' && this.hasAccount) {
        msg = 'Broker is registered with Highway and connected to you';
      } else if (this.status == 'needs_to_onboard' && this.hasAccount) {
        msg =
          'Broker is registered with Highway and in your network, but needs to onboard';
      } else if (this.status == 'onboarded' && !this.hasAccount) {
        msg =
          'Broker is in your network and already onboarded, but is not registered with Highway';
      } else if (this.status == 'needs_to_onboard' && !this.hasAccount) {
        msg =
          'Broker is in your network, but needs to onboard and is not registered with Highway';
      } else if (this.status == 'do_not_dispatch') {
        msg = 'Broker is registered with Highway, but is not connected to you';
      } else if (
        this.status == 'needs_to_onboard_but_can_remain_active' &&
        this.hasAccount
      ) {
        msg =
          'Broker is in your network, but needs to onboard again and is registered with Highway';
      } else if (
        this.status == 'needs_to_onboard_but_can_remain_active' &&
        !this.hasAccount
      ) {
        msg =
          'Broker is in your network, but needs to onboard again and is not registered with Highway';
      } else if (this.status == false && this.hasAccount) {
        msg = 'Broker is registered with Highway, but is not connected to you';
      } else if (this.status == false && !this.hasAccount) {
        msg =
          'Broker is not registered with Highway and is not connected to you';
      }

      this.$emit('popper-message-sent', msg);
    },
  },
};
</script>
